import React from 'react';
import { MediaContext } from './MediaProvider';
export var useMediaSettings = function useMediaSettings() {
  var _ref = React.useContext(MediaContext) || {},
    settings = _ref.settings;
  return settings || {};
};